<template>
    <div class="agreement">
        <h2>認定登録<strong>に関する規約</strong></h2>
        <ol>
            <li><h3>1. 認定登録について</h3>
                <p>
                    認定登録手続きは必ずご本人自身で認定登録フォーム（本登録システム）に入力してください。<br/>
                    第三者による登録によって、トラブル等が生じた場合、当協会は一切責任を負いません。<br/>
                    認定登録は、本登録システムにて認定手続きを行った時点で成立するものとします。但し、振込が必要な場合は、入金された時点で成立とします。<br/>
                    本登録システムにて登録された住所の間違いや不在により、認定証・その他重要書類が当協会に返却された場合、再発送手数料を頂戴いたしますのでご注意ください。<br/>
                    認定登録手続き後のキャンセルは一切お受けいたしません。</p></li>
            <li><h3>2. 認定証について</h3>
                <p>
                    認定証には本登録システムで登録された氏名が記載されます。<br/>
                    認定証印刷後の氏名修正等はいたしかねます。<br/>
                    再発行には再発行手数料が必要となります。</p></li>
            <li><h3>3. 資格の更新</h3>
                <p>
                    資格認定の更新は５年毎です。資格認定期間中（５年間）に資格更新に必要な単位を取得することで資格の更新ができます。<br/>
                    認定登録後は資格更新システム【ココシンク】に登録いただきます。<br/>
                    主にオンラインでの動画視聴や講義の受講、また、セミナーなどに参加していただくことで、資格の更新に必要な単位を取得できます。<br/>
                    ココシンクは、ココシンクの利用規約、及びガイドラインに基づき運営いたします。</p></li>
            <li><h3>4. 個人情報の取り扱い</h3>
                <p>
                    当協会は本登録システムで入力した【氏名、電話番号、住所、生年月日、メールアドレス、職種】等の情報（以下「個人情報等」といいます。）を、今後の当協会とのやり取り（認定証の発送及び郵送・重要事項の連絡等）に使用させていただきます。お間違えの無いように入力してください。<br/>
                    個人情報等は当協会ホームページ上で公開する個人情報の保護方針、ご提供いただく個人情報の利用目的、取り扱い目的に準じて管理します。<br/>
                    また、資格更新システム【ココシンク】へ登録いただく際に、本登録システムで登録された情報を会員情報として使用します。<br/>
                    個人情報等は運営元であるアステッキホールディングス株式会社の個人情報の保護方針、ご提供いただく個人情報の利用目的、取り扱い目的に準じて管理します。<br/>
                </p></li>
            <li><h3>5. 登録変更届</h3>
                <p>
                    在宅看護指導士の方へのお知らせを当協会から随時お送りします。重要なお知らせを確実にお届けするため、氏名変更、転居、転勤、退職、メールアドレスの変更等をされた際は必ず登録変更の手続きをしてください。</p>
            </li>
            <li>
                <h3>6. 認定登録解除について</h3>
                <p>
                    以下のいずれかに該当した場合、当協会は、通知催告等何らの手続を要することなく、認定登録を解除できるものとします。
                </p>
                <ul class="circle">
                    <li><p>単位が不足し、更新手続きができなかった場合。</p></li>
                    <li><p>期日内に更新手続きを行わなかった場合。</p></li>
                    <li><p>認定登録を受けた者が本規約の定めに違反、または違反するおそれのある行為を行い、当協会から当該行為の是正を求められたにもかかわらず、相当の期間内にこれを是正しなかった場合。</p></li>
                    <li><p>認定登録を受けた者が当協会の提供するサービスの利用にかかる契約に準じてサービスをご利用いただけていない場合、または違反のおそれがあると当協会において判断した場合。</p></li>
                    <li><p>認定登録を受けた者が当協会規約に違反した場合または違反のおそれがあると当協会において判断した場合。</p></li>
                    <li><p>当協会が業務を遂行するにあたり、当協会の業務遂行上支障が生じる場合またはそのおそれがあると当協会において判断した場合。</p></li>
                    <li><p>その他、当協会が在宅看護指導士としてふさわしくないと判断した場合。</p></li>
                </ul>
            </li>
        </ol>
    </div>
</template>

<script>
import FormInput from "./FormInput";
import ErrorText from "../ErrorText";

export default {
    name: "Agreement",
    components: {ErrorText, FormInput},
}
</script>

<style scoped>

</style>
